import { T, uuid } from 'src/shared/helpers';
import { createEmpty, ProductConfigurationState } from '.';
import { Side } from './side';

export const initialSide: Side = {
    sideID: null,
    name: T._('Front', 'Admin'),
    guid: uuid()
};

export const initialState: ProductConfigurationState = {
    product: createEmpty(initialSide),
    salesChannelID: 'guid://Zakeke/SalesChannel/1',
    merchantProduct: null,
    providerProduct: null,
    sides: [initialSide],
    currentStep: 'add-product',
    sideImageUploads: [],
    mode: 'none',
    provider: 'ZAKEKE',
    supportedVariants: true,
    ecommerceSalesChannel: [],
    productImageUploadProgress: null,
    disabledModelSides: [],
    headerDescriptionCustomComponent: null,
    alreadyDoneRedirectToSceneEditor: false
};
